import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListarDeclaracoesFiscaisComponent } from './listar-declaracoes-fiscais/listar-declaracoes-fiscais.component';
import { TableModule } from 'primeng/table';
import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';
import { ToolbarModule } from 'primeng/toolbar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DetalhesDeclaracoesFiscaisComponent } from './detalhes-declaracoes-fiscais/detalhes-declaracoes-fiscais.component';
import { TabViewModule } from 'primeng/tabview';
import { RouterModule } from '@angular/router';
import { DeclaracoesFiscaisRoutingModule } from './delcaracoes-fiscais.routing.module';
import { ToolbarSearchComponent } from '../../shared/toolbarSearch/toolbarSearch.component';

@NgModule({
  declarations: [
    ListarDeclaracoesFiscaisComponent,
    DetalhesDeclaracoesFiscaisComponent
  ],

  imports: [
    CommonModule,
    TableModule,
    ToolbarModule,
    SpinnerServiceComponent,
    InputTextModule,
    ButtonModule,
    PaginatorModule,
    TooltipModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    TabViewModule,
    RouterModule,
    DeclaracoesFiscaisRoutingModule,
    ToolbarSearchComponent
  ],
  exports: [
    ListarDeclaracoesFiscaisComponent,
    DetalhesDeclaracoesFiscaisComponent
  ],
})
export class DeclaracoesFiscaisModule { }
